import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Dashboard from '@/views/Dashboard.vue'
import Packages from '@/views/Packages.vue'
import { auth } from '@/library/firebase'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/packages',
    name: 'Packages',
    component: Packages
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import( /* webpackChunkName: "Contact" */ '../views/Contact.vue')
  },
  {
    path: '/documents',
    name: 'Download Documents',
    component: () => import( /* webpackChunkName: "Documents" */ '../views/Documents.vue'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/clients',
    name: 'Clients',
    component: () => import( /* webpackChunkName: "clients" */ '../views/Clients.vue'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import( /* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import( /* webpackChunkName: "signup" */ '../views/Signup.vue')
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import( /* webpackChunkName: "settings" */ '../views/Settings.vue'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/update-profile',
    name: 'Update Profile',
    component: () => import( /* webpackChunkName: "updateprofile" */ '../views/UpdateProfile.vue'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/draft-feedback',
    name: 'Patent Application Draft Feedback',
    component: () => import( /* webpackChunkName: "draftFeedback" */ '../views/DraftFeedback.vue'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/schedule',
    name: 'Schedule',
    component: () => import( /* webpackChunkName: "schedule" */ '../views/Schedule.vue'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/supporting-details',
    name: 'Supporting Details',
    component: () => import( /* webpackChunkName: "supportingDetails" */ '../views/SupportingDetails.vue'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/sign-engagement-letter',
    name: 'Sign Engagement Letter',
    component: () => import( /* webpackChunkName: "signEngagementLetter" */ '../views/SignEngagementLetter.vue'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: () => import( /* webpackChunkName: "privacyPolicy" */ '../views/PrivacyPolicy.vue')
  },
  {
    path: '/terms-of-service',
    name: 'Terms Of Service',
    component: () => import( /* webpackChunkName: "termsOfService" */ '../views/TermsOfService.vue')
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import( /* webpackChunkName: "faq" */ '../views/FAQ.vue')
  },
  {
    path: '/company',
    name: 'Company',
    component: () => import( /* webpackChunkName: "company" */ '../views/Company.vue')
  },
  {
    path: '*',
    component: () => import( /* webpackChunkName: "notFound" */ '../views/NotFound.vue'),
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    else if (savedPosition) {
      return savedPosition
    }
    else {
      return { x: 0, y: 0 }
    }
  }
})

// navigation guard to check for logged in users
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  if (to.name) {
    document.title = 'Portland Patent - ' + to.name
  }
  if (to.fullPath === '/' && auth.currentUser) {
    next('/dashboard')
  }
  else if (requiresAuth && !auth.currentUser) {
    next('/login')
  }
  else {
    next()
  }
})

export default router
